import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface InstituteState {
	instituteId: number | null;
	applicationId: number | null;
	applicationType: string | null;
	subStep: number;
}

const initialState: InstituteState = {
	instituteId: null,
	applicationId: 19,
	applicationType: null,
	subStep: 0,
};

const instituteSlice = createSlice({
	name: "institute",
	initialState,
	reducers: {
		setInstituteData(
			state,
			action: PayloadAction<{ instituteId: number; applicationId: number; applicationType: string }>,
		) {
			state.instituteId = action.payload.instituteId;
			state.applicationId = action.payload.applicationId;
			state.applicationType = action.payload.applicationType;
		},
		clearInstituteData(state) {
			state.instituteId = null;
			state.applicationId = null;
			state.applicationType = null;
		},
		setSubStep(state, action: PayloadAction<number>) {
			state.subStep = action.payload;
		},
		incrementSubStep(state) {
			state.subStep += 1;
		},
		decrementSubStep(state) {
			state.subStep = Math.max(0, state.subStep - 1);
		},
	},
});

export const { setInstituteData, clearInstituteData, setSubStep, incrementSubStep, decrementSubStep } =
	instituteSlice.actions;

export default instituteSlice.reducer;
